import WebSocketWorker from 'workerize-loader!../Services/WebsocketService' // eslint-disable-line import/no-webpack-loader-syntax

export default WebSocketWorker()
